import { SUPPORT_KEY_FLOW_CREATE } from 'js/constants/supportPageKeys';
import React from 'react';
import FlowDetailViewContainer from '../data_flows/cards/FlowDetailViewContainer';
import SourcePipelineContainer from '../pipelines/SourcePipelineContainer';
import ModalCloneFlowContainer from './ModalCloneFlowContainer';
import PipelineFormHeader from './PipelineFormHeader';

class PipelineForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cloneSelectedFlow: null,
    };
    this._loadPipeline = this._loadPipeline.bind(this);
  }

  componentDidMount() {
    this._loadPipeline();
    this.props.setContextualSupport(SUPPORT_KEY_FLOW_CREATE);
  }

  componentWillUnmount() {
    this.props.unsetContextualSupport(SUPPORT_KEY_FLOW_CREATE);
  }

  componentDidUpdate(prevProps, prevState) {
    // if a new Nexset is added (by copying an existing one), reload pipeline
    if (
      prevProps.lastAddedDataSetId !== this.props.lastAddedDataSetId ||
      prevProps.lastAddedSinkId !== this.props.lastAddedSinkId
    ) {
      this._loadPipeline();
    }
  }

  _toggleCloneFlowModal = (data = null) => {
    this.setState({ cloneSelectedFlow: data });
  };

  render() {
    const { flowNodeId, source } = this.props;

    return (
      <section className="pipeline-form">
        {this.props.selectedCardID && <FlowDetailViewContainer />}
        <PipelineFormHeader source={source} toggleCloneFlowModal={this._toggleCloneFlowModal} />
        {(!flowNodeId || source) && (
          <SourcePipelineContainer
            dataSource={source}
            scaleFactor={1}
            showLogs
            onReloadPipeline={this._loadPipeline} //TODO: is this used?
            refreshPipeline={this._loadPipeline}
            editPage={true}
          />
        )}
        {/* Clone Flow Modal */}
        {!!this.state.cloneSelectedFlow && (
          <ModalCloneFlowContainer
            data={this.state.cloneSelectedFlow}
            toggleCloneFlowModal={this._toggleCloneFlowModal}
          />
        )}
      </section>
    );
  }

  _loadPipeline() {
    const { flowNodeId } = this.props;

    if (flowNodeId) {
      // Reload the flow structure only. Per-node metrics are owned by FlowNodes,
      // which fetches them honoring the selected interval on load, on interval
      // change, and on Refresh — see FlowNodes `fetchFlowMetrics`. Firing metrics
      // here would hardcode lifetime and ignore the interval selector.
      this.props.loadPipeline(flowNodeId, {
        isPreview: false,
        ignoreErrors: false,
      });
    }
  }
}

export default PipelineForm;
